import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/stores";
import { DateRange } from "@/domains/common";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";

interface OperatorMemberWithdrawState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: OperatorMemberWithdrawState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const operatorMemberWithdrawSelects = {
  loading: (state: RootState) => state.operatorMemberWithdraw.loading,
  dateRange: (state: RootState) => state.operatorMemberWithdraw.dateRange,
  queryParams: (state: RootState) => state.operatorMemberWithdraw.queryParams,
  transfers: (state: RootState) => state.operatorMemberWithdraw.transfers,
};

export const operatorMemberWithdrawThunks = {
  list: createAsyncThunk(
    "operatorMemberWithdraw/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.MemberWithdraw,
      }).run();

      return res.data.msg;
    }
  ),
};

export const operatorMemberWithdrawSlice = createSlice({
  name: "operatorMemberWithdraw",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(operatorMemberWithdrawThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      operatorMemberWithdrawThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(operatorMemberWithdrawThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const operatorMemberWithdrawActions =
  operatorMemberWithdrawSlice.actions;
